import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { referansAPI } from '../api/api';
import './ReferansYonetim.css';
import { onayla } from '../utils/onayla';

const ReferansYonetim = () => {
  const { user } = useAuth();
  const [referanslar, setReferanslar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingReferans, setEditingReferans] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  useEffect(() => {
    if (user && (user.Role === 'Admin' || user.role === 'Admin')) {
      loadReferanslar();
    }
  }, [user]);

  const loadReferanslar = async () => {
    try {
      setLoading(true);
      const data = await referansAPI.getAll();
      setReferanslar(data);
    } catch (error) {
      console.error('Referanslar yüklenirken hata:', error);
      alert('Referanslar yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      alert('Referans adı gereklidir!');
      return;
    }

    try {
      if (editingReferans) {
        await referansAPI.update({
          id: editingReferans.id,
          name: formData.name.trim(),
          description: formData.description.trim() || null,
          isActive: editingReferans.isActive
        });
        alert('Referans başarıyla güncellendi!');
      } else {
        await referansAPI.create({
          name: formData.name.trim(),
          description: formData.description.trim() || null
        });
        alert('Referans başarıyla eklendi!');
      }
      setShowForm(false);
      setEditingReferans(null);
      setFormData({ name: '', description: '' });
      loadReferanslar();
    } catch (error) {
      console.error('Referans kaydedilirken hata:', error);
      alert('Hata: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleEdit = (referans) => {
    setEditingReferans(referans);
    setFormData({
      name: referans.name,
      description: referans.description || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!await onayla('Bu referansı silmek istediğinize emin misiniz?')) {
      return;
    }

    try {
      await referansAPI.delete(id);
      alert('Referans başarıyla silindi!');
      loadReferanslar();
    } catch (error) {
      console.error('Referans silinirken hata:', error);
      alert('Hata: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleToggleActive = async (referans) => {
    try {
      await referansAPI.update({
        id: referans.id,
        name: referans.name,
        description: referans.description,
        isActive: !referans.isActive
      });
      loadReferanslar();
    } catch (error) {
      console.error('Referans durumu güncellenirken hata:', error);
      alert('Hata: ' + (error.response?.data?.message || error.message));
    }
  };

  const isAdmin = () => {
    if (!user) return false;
    const role = user.Role ?? user.role ?? '';
    return role === 'Admin';
  };

  if (!isAdmin()) {
    return <div className="unauthorized">Bu sayfaya erişim yetkiniz yok.</div>;
  }

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <div className="referans-yonetim-container">
      <div className="page-header">
        <h1>Referans Yönetimi</h1>
        <button className="btn btn-primary" onClick={() => {
          setShowForm(true);
          setEditingReferans(null);
          setFormData({ name: '', description: '' });
        }}>
          + Yeni Referans Ekle
        </button>
      </div>

      {showForm && (
        <div className="form-modal">
          <div className="form-content">
            <h2>{editingReferans ? 'Referans Düzenle' : 'Yeni Referans Ekle'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Referans Adı *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Örn: Ahmet"
                />
              </div>
              <div className="form-group">
                <label>Açıklama</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Referans hakkında açıklama..."
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  {editingReferans ? 'Güncelle' : 'Ekle'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowForm(false);
                    setEditingReferans(null);
                    setFormData({ name: '', description: '' });
                  }}
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="referanslar-table-container">
        <table className="referanslar-table">
          <thead>
            <tr>
              <th>Ad</th>
              <th>Açıklama</th>
              <th>Durum</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {referanslar.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">Henüz referans bulunmamaktadır.</td>
              </tr>
            ) : (
              referanslar.map((referans) => (
                <tr key={referans.id}>
                  <td>{referans.name}</td>
                  <td>{referans.description || '-'}</td>
                  <td>
                    <span className={`status-badge ${referans.isActive ? 'active' : 'inactive'}`}>
                      {referans.isActive ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        type="button"
                        className="btn btn-sm btn-edit"
                        onClick={() => handleEdit(referans)}
                      >
                        Düzenle
                      </button>
                      <button
                        className={`btn btn-sm ${referans.isActive ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => handleToggleActive(referans)}
                      >
                        {referans.isActive ? 'Pasifleştir' : 'Aktifleştir'}
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(referans.id)}
                      >
                        Sil
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReferansYonetim;

